import React from "react";
import { useStore } from "../../store";
import { SetupWizard } from "../wizard/SetupWizard";
import { SettingsContent } from "./SettingsContent";
import { ModalType } from "../../store/types";

// Modal content registry
const modalRegistry: Record<
  Exclude<ModalType, null>,
  { title: string; node: React.ReactNode }
> = {
  wizard: { title: "Setup Procedure", node: <SetupWizard /> },
  settings: { title: "Settings", node: <SettingsContent /> },
};

export const Modal: React.FC = () => {
  const { currentModal, closeModal } = useStore();
  if (!currentModal) return null;

  const entry = modalRegistry[currentModal];
  if (!entry) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-crane-backdrop bg-opacity-75"
        onClick={closeModal}
      />

      {/* Modal Content */}
      <div className="relative bg-crane-surface border border-crane-darker rounded-lg shadow-2xl max-w-6xl w-full mx-4 max-h-[90vh] overflow-hidden">
        {entry.title && (
          <div className="px-6 py-4 border-b border-crane-darker">
            <h2 className="crane-text-heading-lg">{entry.title}</h2>
          </div>
        )}

        <div className="p-6">{entry.node}</div>
      </div>
    </div>
  );
};
